import { Icon } from "@validereinc/common-components";
import classNames from "classnames/bind";
import React, { useState } from "react";
import styles from "./DebugTooltip.module.scss";

const cx = classNames.bind(styles);

type DebugTooltipProps = {
  id: string;
  positionAbsoluteX: number;
  positionAbsoluteY: number;
  selected?: boolean;
  dragging?: boolean;
  variant?: string;
  isTranslucent?: boolean;
};

/**
 * Debug tooltip component that displays development information for workflow graph nodes.
 * Only renders when in development mode.
 */
export const DebugTooltip = ({
  id,
  positionAbsoluteX,
  positionAbsoluteY,
  selected,
  dragging,
  variant,
  isTranslucent,
}: DebugTooltipProps) => {
  const [debugTooltipVisible, setDebugTooltipVisible] = useState(false);

  const toggleDebugTooltip = (e: React.MouseEvent) => {
    e.stopPropagation();
    setDebugTooltipVisible((prev) => !prev);
  };

  // Derive fixed position from coordinates
  const hasFixedPosition = positionAbsoluteX !== 0 || positionAbsoluteY !== 0;

  if (process.env.NODE_ENV !== "development") return null;

  return (
    <div className={cx("debug-icon-container")}>
      <div
        className={cx("debug-icon")}
        onClick={toggleDebugTooltip}
        role="button"
        tabIndex={0}
      >
        <Icon
          variant="info"
          size={16}
        />
      </div>
      {debugTooltipVisible && (
        <div className={cx("debug-tooltip")}>
          <div className={cx("debug-tooltip-title")}>Debug Info</div>
          <div className={cx("debug-tooltip-content")}>
            <div>
              <strong>ID:</strong> {id}
            </div>
            <div>
              <strong>Position:</strong> ({Math.round(positionAbsoluteX)},{" "}
              {Math.round(positionAbsoluteY)})
            </div>
            <div>
              <strong>Selected:</strong> {selected ? "Yes" : "No"}
            </div>
            <div>
              <strong>Dragging:</strong> {dragging ? "Yes" : "No"}
            </div>
            {variant && (
              <div>
                <strong>Variant:</strong> {variant}
              </div>
            )}
            <div>
              <strong>Has Position in Config:</strong>{" "}
              {hasFixedPosition ? "Yes" : "No"}
            </div>
            {isTranslucent && (
              <div>
                <strong>Translucent:</strong> Yes
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};
